// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.difference_layout__-BDz5 {
  display: grid;
  gap: var(--space-7);
  grid-template-columns: minmax(0, 1fr);
}
.difference_sticky__KYF-q h2 {
  color: #fff;
}
.difference_points__wgQMX {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--color-border-on-dark);
}
.difference_point__Hpky\\+ {
  display: grid;
  gap: var(--space-4);
  grid-template-columns: minmax(0, 1fr);
  padding: clamp(1.5rem, 1rem + 1.5vw, 2.25rem) 0;
  border-bottom: 1px solid var(--color-border-on-dark);
}
.difference_figure__-sJUl {
  margin: 0;
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
  flex-wrap: wrap;
}
.difference_big__8UAmy {
  font-size: clamp(2.4rem, 1.7rem + 3vw, 4.25rem);
  line-height: 1;
  font-weight: 500;
  letter-spacing: var(--tracking-figure);
  color: var(--color-accent);
}
.difference_word__II\\+Yc {
  font-size: clamp(1.6rem, 1.3rem + 1.2vw, 2.25rem);
  letter-spacing: var(--tracking-subheading);
}
.difference_unit__u0109 {
  font-size: var(--text-caption);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-text-muted-on-dark);
}
.difference_pointTitle__NBW4G {
  margin: 0 0 var(--space-2);
  font-size: var(--text-h3);
  font-weight: 500;
  line-height: var(--leading-heading);
}
.difference_pointText__YA0Bm {
  margin: 0;
  max-width: 34rem;
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}

@media (min-width: 992px) {
  .difference_layout__-BDz5 {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: var(--space-8);
    align-items: start;
  }
  .difference_sticky__KYF-q {
    position: sticky;
    top: 7rem;
  }
  .difference_sticky__KYF-q header {
    margin-bottom: 0;
  }
  .difference_point__Hpky\\+ {
    /* figure column fits its widest word ("Community") so it never splits */
    grid-template-columns: minmax(13rem, max-content) minmax(0, 1fr);
    column-gap: var(--space-6);
    align-items: start;
  }
}
/* every row shares one figure column sized to the widest figure
   ("Community"), so all the titles and text start on the same line */
@supports (grid-template-columns: subgrid) {
  @media (min-width: 992px) {
    .difference_points__wgQMX {
      display: grid;
      grid-template-columns: max-content minmax(0, 1fr);
      column-gap: var(--space-6);
    }
    .difference_point__Hpky\\+ {
      grid-column: 1 / -1;
      grid-template-columns: subgrid;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/DIFFERENCE/difference.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;EAC/C,oDAAoD;AACtD;AACA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE;IACE,wDAAwD;IACxD,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wEAAwE;IACxE,gEAAgE;IAChE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;AACA;qEACqE;AACrE;EACE;IACE;MACE,aAAa;MACb,iDAAiD;MACjD,0BAA0B;IAC5B;IACA;MACE,mBAAmB;MACnB,8BAA8B;IAChC;EACF;AACF","sourcesContent":[".layout {\n  display: grid;\n  gap: var(--space-7);\n  grid-template-columns: minmax(0, 1fr);\n}\n.sticky :global(h2) {\n  color: #fff;\n}\n.points {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--color-border-on-dark);\n}\n.point {\n  display: grid;\n  gap: var(--space-4);\n  grid-template-columns: minmax(0, 1fr);\n  padding: clamp(1.5rem, 1rem + 1.5vw, 2.25rem) 0;\n  border-bottom: 1px solid var(--color-border-on-dark);\n}\n.figure {\n  margin: 0;\n  display: flex;\n  align-items: baseline;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n}\n.big {\n  font-size: clamp(2.4rem, 1.7rem + 3vw, 4.25rem);\n  line-height: 1;\n  font-weight: 500;\n  letter-spacing: var(--tracking-figure);\n  color: var(--color-accent);\n}\n.word {\n  font-size: clamp(1.6rem, 1.3rem + 1.2vw, 2.25rem);\n  letter-spacing: var(--tracking-subheading);\n}\n.unit {\n  font-size: var(--text-caption);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--color-text-muted-on-dark);\n}\n.pointTitle {\n  margin: 0 0 var(--space-2);\n  font-size: var(--text-h3);\n  font-weight: 500;\n  line-height: var(--leading-heading);\n}\n.pointText {\n  margin: 0;\n  max-width: 34rem;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n    gap: var(--space-8);\n    align-items: start;\n  }\n  .sticky {\n    position: sticky;\n    top: 7rem;\n  }\n  .sticky :global(header) {\n    margin-bottom: 0;\n  }\n  .point {\n    /* figure column fits its widest word (\"Community\") so it never splits */\n    grid-template-columns: minmax(13rem, max-content) minmax(0, 1fr);\n    column-gap: var(--space-6);\n    align-items: start;\n  }\n}\n/* every row shares one figure column sized to the widest figure\n   (\"Community\"), so all the titles and text start on the same line */\n@supports (grid-template-columns: subgrid) {\n  @media (min-width: 992px) {\n    .points {\n      display: grid;\n      grid-template-columns: max-content minmax(0, 1fr);\n      column-gap: var(--space-6);\n    }\n    .point {\n      grid-column: 1 / -1;\n      grid-template-columns: subgrid;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `difference_layout__-BDz5`,
	"sticky": `difference_sticky__KYF-q`,
	"points": `difference_points__wgQMX`,
	"point": `difference_point__Hpky+`,
	"figure": `difference_figure__-sJUl`,
	"big": `difference_big__8UAmy`,
	"word": `difference_word__II+Yc`,
	"unit": `difference_unit__u0109`,
	"pointTitle": `difference_pointTitle__NBW4G`,
	"pointText": `difference_pointText__YA0Bm`
};
export default ___CSS_LOADER_EXPORT___;
